import axios from 'axios';

const API = process.env.REACT_APP_API_URL;

export async function getContentBySection(section) {
  const { data } = await axios.get(`${API}/content/${section}`);
  const map = {};
  data.forEach(item => {
    map[item.Key] = item.Value;
  });
  return map;
}